import { render, staticRenderFns } from "./BpcTable.vue?vue&type=template&id=3c49673a&"
import script from "./BpcTable.vue?vue&type=script&lang=js&"
export * from "./BpcTable.vue?vue&type=script&lang=js&"
import style0 from "./BpcTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports